// extracted by mini-css-extract-plugin
export var colorSquare = "_ra-0";
export var danger = "_ra-5";
export var lightPink = "_ra-8";
export var neutralBlue = "_ra-7";
export var neutralYellow = "_ra-6";
export var normal = "_ra-1";
export var primary = "_ra-2";
export var primaryLight = "_ra-3";
export var solidBlack = "_ra-g";
export var solidGreen = "_ra-b";
export var solidLightBlue = "_ra-d";
export var solidNavy = "_ra-c";
export var solidOrange = "_ra-f";
export var solidPink = "_ra-e";
export var solidRed = "_ra-9";
export var solidYellow = "_ra-a";
export var success = "_ra-4";